import { render } from "./ContaReceberIndex.vue?vue&type=template&id=cc2be5da&scoped=true&ts=true"
import script from "./ContaReceberIndex.vue?vue&type=script&lang=ts"
export * from "./ContaReceberIndex.vue?vue&type=script&lang=ts"

import "./ContaReceberIndex.vue?vue&type=style&index=0&id=cc2be5da&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2be5da"]])

export default __exports__